import { render } from "./SzSearchForm.vue?vue&type=template&id=5ff1ac8d&scoped=true"
import script from "./SzSearchForm.vue?vue&type=script&lang=ts"
export * from "./SzSearchForm.vue?vue&type=script&lang=ts"

import "./SzSearchForm.vue?vue&type=style&index=0&id=5ff1ac8d&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5ff1ac8d"

export default script